import { render, staticRenderFns } from "./expertList.vue?vue&type=template&id=835cdaec&scoped=true&"
import script from "./expertList.vue?vue&type=script&lang=js&"
export * from "./expertList.vue?vue&type=script&lang=js&"
import style0 from "./expertList.vue?vue&type=style&index=0&id=835cdaec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835cdaec",
  null
  
)

export default component.exports